import { styled } from '@ui/components';

export const Container = styled('div', {
  alignItems: 'center',
  display: 'flex',
  flexDirection: 'column',
  gap: '1vmin',
  height: '80vh',
  justifyContent: 'center',
  width: '100%',
  '& h1': {
    marginBottom: '0px',
  },
  '& a, span': {
    color: 'Gray',
  },
});